(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicCategoryDeleteController',CommunicationTopicCategoryDeleteController);

    CommunicationTopicCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationTopicCategory'];

    function CommunicationTopicCategoryDeleteController($uibModalInstance, entity, CommunicationTopicCategory) {
        var vm = this;
        vm.communicationTopicCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CommunicationTopicCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
